import Carousel from '@/stories/components/Common/Carousel/Carousel'
import Text from '@/stories/components/Common/NewText'
import Title from '../../common-components/Title'
import { TStrapiV4TestimonialsWidget } from '../../common-types'
import TestimonialCard from './TestimonialCard'

type TProps = TStrapiV4TestimonialsWidget

export const StrapiV4TestimonialWidget = (props: TProps) => {
  const { heading, title, cards, disclaimerText } = props
  return (
    <div className="herolike-wrapper py-8 xl:py-12">
      <Title
        className="mb-5 text-center font-normal lg:mb-8"
        fontSize="size-34"
        style={{ color: '#33A34D' }}
      >
        {heading}
      </Title>
      <Title
        className="lg:w-6/10 mx-auto mb-5 text-center font-semibold lg:mb-8"
        fontSize="size-54"
      >
        {title}
      </Title>
      <Carousel dots>
        <div className="flex flex-row">
          {cards?.map((card, index) => (
            <TestimonialCard key={index} {...card} />
          ))}
        </div>
      </Carousel>
     {disclaimerText && <Text addClassName='italic'>{disclaimerText}</Text>}
    </div>
  )
}
